export const addEmployeeDefaults = {
  // Basic Information
  name: "",
  arabicName: "",
  email: "",
  phone: "",
  nationalId: "",
  idRegion: "",
  dateOfBirth: "",
  age: "",
  gender: "",
  maritalStatus: "",
  nationality: "",
  religion: "",
  militaryStatus: "",
  // Contact Information
  emergencyPhone: "",
  city: "",
  country: "Egypt",
  address: "",
  arabicAddress: "",
  // Work Information
  department: "",
  departmentId: null,
  position: "",
  laborMode: "",
  workingCompany: "",
  company: "",
  contractCompany: "",
  clientCode: "",
  accountNumber: "",
  status: "Active",
  salary: "",
  hiringDate: "",
  transportationAllowances: "",
  variableSalary: "",
  firstLineManagerCode: "",
  firstLineManagerName: "",
  secondLineManagerCode: "",
  secondLineManagerName: "",
  // Working Age
  workingAgeYears: "",
  workingAgeMonths: "",
  // Contract Information
  contractDate: "",
  termOfContract: "",
  contractExpiration: "",
  lastContractDate: "",
  lastContractTerm: "",
  lastContractExpiration: "",
  beRegularDate: "",
  toBeRegular: "",
  periodForBeingRegular: "",
  resignedDate: "",
  resignReasons: "",
  // Education Information
  graduateInstitution: "",
  major: "",
  graduationYear: "",
  // Insurance Information
  insuredBeginningDate: "",
  insuranceStatus: "",
  monthsForInsurance: "",
  insuranceNumber: "",
  insuranceSalary: "",
  medicalInsuranceStage: "",
  medicalNumber: "",
  // HR / Other
  uniformSize: "",
  drivingLicenseDegree: "",
  drivingLicenseExpiry: "",
  drivingLicenseStillValid: false,
  accountNumber: "",
  location: "",
  delivered: false,
  // Health Certificate
  healthCertificateOB: false,
  healthCertExpiryDate: "",
  healthCertStillValid: false,
  // Documents Checklist
  idCopy: false,
  gradCertificateOriginal: false,
  birthCertificateCopy: false,
  militaryServiceCertificate: false,
  laborLetterOriginal: false,
  noCrimeCertificate: false,
  photosCount: false,
  formNo6Original: false,
  medicalCheckForm111: false,
  didMedicalCheck: false,
  medicalReportOriginal: false,
  lawyerCertificateCopy: false,
  driversLicenseCopy: false,
  testEngineerCertificate: false,
  accountantCertificate: false,
};